import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export const LD_INPUT =
  'ld-input ld-motion w-full';
export const LD_TEXTAREA =
  'ld-textarea ld-motion w-full';
export const LD_NATIVE_SELECT =
  'ld-native-select ld-motion mt-3 block w-full';
export const LD_SELECT_TRIGGER =
  'ld-select-trigger ld-motion mt-1 h-10 w-full';

export function LeadDetailCard({
  title,
  children,
  className,
  id,
}: {
  title?: string;
  children: ReactNode;
  className?: string;
  id?: string;
}) {
  return (
    <section id={id} className={cn('ld-card ld-motion', className)}>
      {title ? (
        <header className="ld-card-header">
          <span className="ld-card-dot" aria-hidden />
          <h3 className="ld-card-title">{title}</h3>
        </header>
      ) : null}
      {children}
    </section>
  );
}

export function LeadDetailFieldLabel({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return <label className={cn('ld-field-label', className)}>{children}</label>;
}
